// extracted by mini-css-extract-plugin
export default {"container":"TheTvdb-container-ClQxr","info":"TheTvdb-info-DRsTr","title":"TheTvdb-title-SVfAE","image":"TheTvdb-image-_vxKl"};